import { Table, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { formatToDollar, formatDate } from '../../../../helpers/genericHelper';
import Data from '../../../CustomText/data';

function SpendLimitChangesComponent({ spendLimitChanges = [], domain }) {

    const isHigherSpendLimitEnabled = domain?.creditLimitIncentivesHigherSpendLimitEnabled;
    const minimumSpendLimit = domain?.creditLimitIncentivesHigherSpendLimitEnabled ? 50 : 25;

    // Define the columns for the table
    const columns = [
        {
            title: 'Date',
            dataIndex: 'created',
            key: 'created',
            render: (text) => formatDate(text, true),
        },
        {
            title: (
                <>
                    Spend Limit{' '}
                    <Tooltip title={
                        `= SB Contribution + Credit Limit Contribution + Gifted Spend. Minimum of $${minimumSpendLimit}.`
                        + ` ${isHigherSpendLimitEnabled ? ' -- Minimum (Annual: $100, Monthly: $50)' : ''}`}>
                        <InfoCircleOutlined />
                    </Tooltip>
                </>
            ),
            dataIndex: 'spendLimitDollars',
            key: 'spendLimitDollars',
            render: (text) => formatToDollar(text),
        },
        {
            title: (
                <>
                    SB Contrib.{' '}
                    <Tooltip title={
                        <>
                            <div><strong>Monthly:</strong> 50% of the SB deposits</div>
                            <div><strong>Annual:</strong> 70% of the SB deposits</div>
                            <div>Must be successful deposits. Starts only after 2 consecutive monthly deposits</div>
                        </>
                    }>
                        <InfoCircleOutlined/>
                    </Tooltip>
                </>
            ),
            dataIndex: 'sbContributionDollars',
            key: 'sbContributionDollars',
            render: (text) => formatToDollar(text),
        },
        {
            title: 'SB Balance',
            dataIndex: 'totalSbBalanceDollars',
            key: 'totalSbBalanceDollars',
            render: (text) => formatToDollar(text),
        },
        {
            title: 'Credit Limit',
            dataIndex: 'totalCreditLimitDollars',
            key: 'totalCreditLimitDollars',
            render: (text) => formatToDollar(text),
        },
        {
            title: (
                <>
                    Credit Limit Contrib.{' '}
                    <Tooltip title="This amount will increase by 1% each month, up to a maximum of 5% of your credit limit.">
                        <InfoCircleOutlined />
                    </Tooltip>
                </>
            ),
            dataIndex: 'creditLimitContributionDollars',
            key: 'creditLimitContributionDollars',
            render: (text) => formatToDollar(text),
        },
        {
            title: 'Gifted Spend',
            dataIndex: 'giftedSpendDollars',
            key: 'giftedSpendDollars',
            render: (text) => formatToDollar(text),
        },
        {
            title: 'Annual Subscription',
            dataIndex: 'hasAnnualSubscription',
            key: 'hasAnnualSubscription',
            render: (text) => text ? 'Yes' : 'No',
        },
        {
            title: 'Change Reason',
            dataIndex: 'changeReason',
            key: 'changeReason',
        },
    ];
    return (
        <>
            <h3>
                Spend Limit Changes
                <Data isTag tagColor={domain?.creditLimitIncentivesHigherSpendLimitEnabled ? 'success' : 'error'} title="Higher Spend Limit Enabled" value={domain?.creditLimitIncentivesHigherSpendLimitEnabled ? 'Yes' : 'No'} />
            </h3>
            <Table
                columns={columns}
                dataSource={spendLimitChanges}
                rowKey="id"
                pagination={{ pageSize: 5 }}
            />
        </>
    );
}

export default SpendLimitChangesComponent;
